import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, map, pluck, publishReplay, refCount, take } from 'rxjs/operators';

export const PDP_PRICE = 'pdp-price';
export const PDP_PROMOTION = 'pdp-promotion';
export const PLP_DEALER_PRICE = 'plp-dealer-price';
export const CAROUSEL_HIGHLIGHTED_PRODUCTS = 'carousel-highlighted-products';
export const CAROUSEL_ALTERNATIVE_PRODUCTS = 'carousel-alternative-products';
export const CAROUSEL_NORMAL = 'carousel-normal';
export const PRODUCT_REFERENCES_NOT_UPSELLING = 'carousel-product-references-not-upselling';
export const PRODUCT_REFERENCES_UPSELLING = 'product-references-upselling';
export const QUICK_ORDER = 'quick-order';
export const ORDER_FORM = 'order-form';
export const SAVED_CART_DETAILS = 'saved-cart-details';
export const ORDER_HISTORY_DETAILS = 'order-history-details';

@Injectable({
  providedIn: 'root',
})
export class TooltipIconService {
  // custom tooltip configurable per country
  TOOLTIP_FEATURES_CONFIG = '../../../public/features/TOOLTIP_ICON_FEATURES.json';

  cacheWindowTime = 3600000;
  private cachedTooltipIconConfig$: any = {};

  constructor(private http: HttpClient) {}

  getTooltipFeaturesConfig$(activeCountry: string): Observable<any> {
    if (!this.cachedTooltipIconConfig$[activeCountry]) {
      this.cachedTooltipIconConfig$[activeCountry] = this.http
        .get(this.TOOLTIP_FEATURES_CONFIG)
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandler));
    }
    return this.cachedTooltipIconConfig$[activeCountry];
  }

  getTooltipIconConfig(activeCountry: string, tooltipIconLocation: string): Observable<any> {
    timer(this.cacheWindowTime).subscribe(() => {
      delete this.cachedTooltipIconConfig$[idString];
    });
    const idString = [activeCountry, tooltipIconLocation].join();
    if (!this.cachedTooltipIconConfig$[idString]) {
      this.cachedTooltipIconConfig$[idString] = this.getTooltipFeaturesConfig$(activeCountry).pipe(
        publishReplay(1, this.cacheWindowTime),
        refCount(),
        take(1),
        pluck('country'),
        map((data: any) => {
          const tooltipIcon = data[activeCountry] ? data[activeCountry]['location'][tooltipIconLocation] : null;
          return tooltipIcon ? tooltipIcon : data['default']['location'][tooltipIconLocation];
        }),
        catchError(this.errorHandler)
      );
    }
    return this.cachedTooltipIconConfig$[idString];
  }

  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
